export default __webpack_public_path__ + "static/media/chart1.eaf69d9d.svg";